module.exports = __webpack_public_path__ + "static/adwokat-gdynia-mikulak2-9c2d5d38e25b4e1004963f3879d58bae.jpg";